/* eslint-disable import/order */
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
} from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { getPlansBacklogResource } from '@jira/router-resources__advanced-roadmaps-plan/src/plansBacklogResource.tsx';
import { PORTFOLIO_PLAN_VIEW } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { planLayout } from '@jira/platform__layouts-jira-plan-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import {
	getNavigationResources,
	getNavigationSidebarPlanResources,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { softwarePlanTeamsRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/softwarePlanTeamsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import PlanTeamsPage, { LazyPlanTeams } from './ui/plan-teams/index-old.tsx';
import { planTeamsPageEntryPoint } from './ui/plan-teams/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';

export const softwarePlanTeamsRouteEntry: Route = createEntry(softwarePlanTeamsRoute, () => ({
	group: 'software',
	entryPoint: () => planTeamsPageEntryPoint,
	// eslint-disable-next-line no-restricted-syntax
	component: PlanTeamsPage,
	layout: composeLayouts(globalLayout, planLayout),

	resources: [
		...getNavigationResources(),
		...getNavigationSidebarPlanResources(),
		advancedRoadmapsPlanPageInitialChecksResource,
		...getPlansBacklogResource(),
		advancedRoadmapsReduxStoreStateResource,
	],

	preloadOptions: {
		earlyChunks: ['advanced-roadmaps-early-entry'],
	},

	navigation: {
		menuId: MenuIdPlans,
	},

	forPaint: [LazyAtlassianNavigation, LazyPlanTeams],
	meta: {
		capability: expVal('jpo-42550-improve-capability-tracking', 'isEnabled', false)
			? PORTFOLIO_PLAN_VIEW
			: undefined,
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
